exports = module.exports = require("../../../css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".van-info{position:absolute;top:0;right:0;box-sizing:border-box;min-width:0.16rem;padding:0 0.03rem;color:#fff;font-weight:500;font-size:0.12rem;font-family:-apple-system-font,Helvetica Neue,Arial,sans-serif;line-height:1.2;text-align:center;background-color:#ee0a24;border:0.01rem solid #fff;border-radius:0.16rem;-webkit-transform:translate(50%,-50%);transform:translate(50%,-50%);-webkit-transform-origin:100%;transform-origin:100%}.van-info--dot{width:0.08rem;min-width:0;height:0.08rem;background-color:#ee0a24;border-radius:100%}", ""]);

// exports
